import { useTranslation } from 'react-i18next';

const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: '📋',
      title: t('how.step1_title'),
      description: t('how.step1_desc')
    },
    {
      icon: '🚚',
      title: t('how.step2_title'),
      description: t('how.step2_desc')
    },
    {
      icon: '🔄',
      title: t('how.step3_title'),
      description: t('how.step3_desc')
    }
  ];

  return (
    <section id="how" className="bg-gradient-to-b from-white to-slate-50 py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-slate-900 sm:text-4xl">
            {t('how.title')}
          </h2>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">{t('how.subtitle')}</p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-3">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl mb-4">{step.icon}</div>
              <h3 className="text-lg font-semibold text-slate-900">{step.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
